import { CommonModule } from "@angular/common";
import { Component, DestroyRef, inject, Input } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Actions, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { take } from "rxjs";
import { AutomationActions } from "../../../core/ngrx/actions/automation.actions";
import { ProjectService } from "../../../core/services/project/project.service";
import { RestService } from "../../../core/services/rest.service";
import { ToasterService } from "../../../core/services/toaster-service";
import { scriptMappingColumns } from "../../../core/table-templates/script-mapping-table";
import { ZorroTableComponent } from "../../common/custom-table/zorro-table.component";
import { LoadingComponent } from "../../common/loading/loading.component";
import { MessageEnum } from "../../../core/utils/message.enum";

@Component({
  selector: "app-script-mapping",
  standalone: true,
  imports: [LoadingComponent, ZorroTableComponent, CommonModule],
  templateUrl: "./script-mapping.component.html",
  styleUrl: "./script-mapping.component.scss",
})
export class ScriptMappingComponent {
  @Input()
  data: any = {};

  @Input()
  displaySkip = false;

  @Input()
  displayStep: any = "";

  activeModal = inject(NgbActiveModal);
  private readonly actions$ = inject(Actions);
  private readonly destroyRef = inject(DestroyRef);
  displayLoader = false;
  searchKey: string = "";
  isActive:boolean = false;
  tableData: any = [];
  columns: any = scriptMappingColumns;
  projectID: any;
  automationProjectID: any;
  mappedId: any;
  scriptId: any;
  filteredTableData: any[] = [];


  constructor(
    private restService: RestService,
    public projectService: ProjectService,
    public store: Store,
    private readonly toaster: ToasterService
  ) {}

  ngOnInit() {
    console.log(this.data);
    this.displayLoader = true;
    this.projectID = this.data?.projectId;
    this.automationProjectID = this.data?.automationId;
    this.scriptId = this.data?.scriptId;
    this.getTestCases();
  }

  onSearch(data: any[], searchText: string): any[] {
    const filtered = [];
    const isSearching = searchText?.trim().length > 0;
    for (const item of data) {
      // Filter testCases that match
      const filteredTestCases = item.testCases?.filter((testCase: any) =>
        Object.values(testCase).some(value =>
          typeof value === 'string' &&
          value.toLowerCase().includes(searchText.toLowerCase())
        )
      ) || [];
  
      // Recursively filter children
      const filteredChildren = item.children?.length
        ? this.onSearch(item.children, searchText)
        : [];
  
      // If there are matching testCases or matching children, keep this item
      if (filteredTestCases.length || filteredChildren.length) {
        filtered.push({
          ...item,
          testCases: filteredTestCases,     // Only include matching testCases
          children: filteredTestCases,       // Only include matching children
          ...(isSearching && { expand: true }) 
        });
      }
    }
  
    this.filteredTableData = filtered;
    return filtered;
  }
  

  onRowHandle(params: any) {
    switch (params.type) {
      case "conditional-button":
        //add mapping
        this.displayLoader = true;
        this.mappedId = params?.data?.row?._id;

        // Close only after the mapping is saved: the editor reloads the script
        // on close, and closing right after dispatch raced the save, so the
        // reload missed the mapped test case name. On failure the effect shows
        // an error toast and the modal stays open.
        this.actions$
          .pipe(
            ofType(
              AutomationActions.updateTestScriptSuccess,
              AutomationActions.automationFailure
            ),
            take(1),
            takeUntilDestroyed(this.destroyRef)
          )
          .subscribe((action) => {
            this.displayLoader = false;
            if (action.type === AutomationActions.updateTestScriptSuccess.type) {
              this.activeModal.close();
            }
          });

        this.store.dispatch(
          AutomationActions.mapToTestScript({
            projectId: this.projectID,
            automationProjectId: this.automationProjectID,
            id: this.scriptId,
            mappingId: this.mappedId,
          })
        );
        break;
      default:
        break;
    }
  }

  getTestCases() {
    this.restService.getTestCasesFromTCG(this.projectID).subscribe(
      (response) => {
        this.displayLoader = false;
        this.tableData = response?.data?.map((element: any) => {
          return { ...element, children: element?.testCases };
        });
        this.filteredTableData = this.tableData;
        console.log("this.tableData",this.tableData)
      },
      (error) => {
        this.displayLoader = false;
        const errorMsg = error?.message
          ? error?.message
          : MessageEnum.SOMETHING_WENT_WRONG;
        this.toaster.pop({ type: 'error', text: errorMsg });
      }
    );
  }
}
